<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 1000px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Payment Order Group #{{ group_id }}</p>
      </header>
      <section class="modal-card-body">
        <div class="content" v-if="payment_group">
          <h4 style="margin-top: 0px;"><b>Deadline:</b> {{ payment_group.deadline }}</h4>
          <h4 style="margin-top: 0px;"><b>Currency:</b> {{ payment_group.currency }}</h4>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th>Payment</th>
                <th>Supplier</th>
                <th>Check-in start</th>
                <th>Check-to end</th>
                <th>Value</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="payment in payment_group.payments">
                <td>{{ payment.id }}</td>
                <td>{{ getName(payment) }}</td>
                <td>{{ parseDate(payment.checkin_start) }}</td>
                <td>{{ parseDate(payment.checkin_end) }}</td>
                <td>{{ payment.value }}</td>
                <td style="text-align: center;">
                  <tooltip label="Exclude" type="default" placement="left">
                    <a class="button button-table is-small" @click="exclude(payment.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </tooltip>
                  <tooltip label="View" type="default" placement="left">
                    <a class="button button-table is-small" @click="view(payment.id)">
                      <i class="fa fa-eye"></i>
                    </a>
                  </tooltip>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" style="border:none; text-align: right;"><b>TOTAL</b></td>
                <td colspan="1"><b>{{ getTotal().toFixed(2) }} {{ payment_group.currency }}</b></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(false)">Cancel</a>
          </p>
          <p class="control">
            <template>
              <a class="button is-success" @click="pdf">Export PDF</a>
              <a class="button is-info" @click="csv">Export CSV</a>
              <a class="button is-warning" @click="xls">Export XLS</a>
            </template>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  import Tooltip from 'vue-bulma-tooltip'
  import Payment from '../finances/payment'
  export default {
    props: {
      context: {
        type: Object
      },
      group_id: {
        type: Number,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        payment_group: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      view (id) {
        let propsData = {
          context: this.context,
          payment_id: id,
          edit: true,
          callback: ''
        }
        Payment.openPayment(propsData)
      },
      showExclude () {
        return new Date(this.payment.deadline) >= new Date()
      },
      getName (payment) {
        if (payment.provider !== null) {
          return payment.provider.name + ' - ' + 'Provider'
        } else if (payment.hotel !== null) {
          return payment.hotel.name + ' - ' + 'Hotel'
        } else if (payment.chain !== null) {
          return payment.chain.name + ' - ' + 'Chain'
        }
      },
      getTotal () {
        let total = 0
        for (var x = 0; x < this.payment_group.payments.length; x++) {
          total = parseFloat(total) + parseFloat(this.payment_group.payments[x].value)
        }
        return total
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/payment/group/' + this.group_id).then((response) => {
          this.payment_group = response.body
          if (response.body === '') {
            this.close(false)
          } else {
            document.body.appendChild(this.$el)
          }
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      close (closeOnly, result) {
        if ((!closeOnly) && (typeof this.context[this.callback] === 'function')) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      pdf () {
        window.location.href = this.context.$store.state.config.apiURL + '/payment/group/pdf/' + this.group_id
      },
      xls () {
        window.location.href = this.context.$store.state.config.apiURL + '/payment/group/xls/' + this.group_id
      },
      csv () {
        window.location.href = this.context.$store.state.config.apiURL + '/payment/group/csv/' + this.group_id
      },
      parseDate (content) {
        return this.$moment(content).format('YYYY-MM-DD')
      },
      exclude (id) {
        if (window.confirm('You are sure exclude payment #' + id)) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/group/exclude', {payment: id}).then((response) => {
            let propsData = {
              title: 'Success',
              message: 'The payment was successfully removed',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            message.openMessage(propsData)
            this.loadData()
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      Tooltip
    }
  }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// GroupPaymentView.vue?4787a049